import PackageService from '@/api/PackageService'
import UserService from '@/api/UserService'
import UtilService from '@/utils/UtilService'

const state = {
  activeRound: {},
  ieoBalances: [],
  ieoPackages: [],
  ieoUserRefs: [],
  ieoUserIeo: [],
  selectedBalance: {},
  commissionHistory: {},
  commissionAleoHistory: {},
  commissionBrandHistory: {},
  tokenReleaseHistory: {},
  transactionHistory: {},
  matrixInfo: {},
  affMember: {},
  commissionEstimation: {},
  commissionIronHistory: {}
}

const getters = {
  rounds: state => state.rounds,
  activeRound: state => state.activeRound,
  ieoBalances: state => state.ieoBalances,
  ieoPackages: state => state.ieoPackages,
  ieoUserRefs: state => state.ieoUserRefs,
  ieoUserIeo: state => state.ieoUserIeo,
  selectedBalance: state => state.selectedBalance,
  commissionHistory: state => state.commissionHistory,
  commissionAleoHistory: state => state.commissionAleoHistory,
  commissionBrandHistory: state => state.commissionBrandHistory,
  tokenReleaseHistory: state => state.tokenReleaseHistory,
  transactionHistory: state => state.transactionHistory,
  matrixInfo: state => state.matrixInfo,
  affMember: state => state.affMember,
  commissionIronHistory: state => state.commissionIronHistory,
  commissionEstimation: state => state.commissionEstimation
}

const mutations = {
  SET_MATRIX_INFO: (state, data) => {
    state.matrixInfo = data
  },
  SET_AFF_MEMBER: (state, data) => {
    state.affMember = data
  },
  SET_TRANS_HIS: (state, data) => {
    state.transactionHistory = data
  },
  SET_SELECTED_BALANCE: (state, data) => {
    state.selectedBalance = data
  },
  SET_IEO_REFERRAL: (state, data) => {
    state.ieoUserRefs = data
  },
  SET_COMMISSION_HISTORY: (state, data) => {
    state.commissionHistory = data
  },
  SET_COMMISSION_ALEO_HISTORY: (state, data) => {
    state.commissionAleoHistory = data
  },
  SET_COMMISSION_BRAND_HISTORY: (state, data) => {
    state.commissionBrandHistory = data
  },
  SET_COMMISSION_IRON_HISTORY: (state, data) => {
    state.commissionIronHistory = data
  },
  SET_COMMISSION_ESTIMATION: (state, data) => {
    state.commissionEstimation = data
  },
  SET_TOKEN_RELEASE_HISTORY: (state, data) => {
    state.tokenReleaseHistory = data
  }
}

const actions = {
  setMatrixInfo ({ commit }, data) {
    commit('SET_MATRIX_INFO', data)
  },
  getMatrixInfo ({ commit }) {
    UserService.getUserMatrix().then(rs => {
      rs.status && commit('SET_MATRIX_INFO', rs.data)
    })
  },
  getAffMember ({ commit }) {
    UserService.getAffMember().then(rs => {
      rs.status && commit('SET_AFF_MEMBER', rs.data)
    }).catch(e => Promise.resolve([]))
  },
  getAffMemberByLevel ({ commit, state }, level) {
    UserService.getAffMemberByLevel(level).then(rs => {
      if (rs.status && rs.data[level].length) {
        const affMember = JSON.parse(JSON.stringify(state.affMember))
        affMember[level] = rs.data[level]
        commit('SET_AFF_MEMBER', affMember)
        Promise.resolve(rs.data[level])
      } else Promise.resolve([])
    }).catch(e => Promise.resolve([]))
  },
  setSelectedBalance ({ commit }, data) {
    commit('SET_SELECTED_BALANCE', data)
  },
  getTransHistory ({ commit }, page) {
    page = page || 1
    UserService.tranHistory(page).then(res => {
      const paginationRes = res.pagination
      const result = res.data || {}
      commit('SET_TRANS_HIS', UtilService.transformTransHistory(result))
      const pagination = {
        currentPage: paginationRes.page,
        totalPage: paginationRes.total_pages,
        totalRecord: paginationRes.total_records
      }
      this.dispatch('setPagination', pagination)
    })
  },
  getUserReferral ({ commit }, data) {
    return new Promise((resolve, reject) => {
      PackageService.getUserReferral(data).then(res => {
        const result = res.data
        const paginationRes = res.pagination
        result && commit('SET_IEO_REFERRAL', UtilService.transformUserIeoRef(result) || [])
        const pagination = {
          currentPage: paginationRes.page,
          totalPage: paginationRes.total_pages,
          totalRecord: paginationRes.total_records
        }
        this.dispatch('setPagination', pagination)
        resolve(result)
      }).catch(e => {
        reject(e)
      })
    })
  },
  getCommissionRefHistory ({ commit }, param) {
    const page = param.page || 1
    PackageService.getCommissionRefHistory(param.symbol, page).then(res => {
      const result = res.data || {}
      const paginationRes = res.pagination
      commit('SET_COMMISSION_HISTORY', UtilService.transformCommHistory(result))
      const pagination = {
        currentPage: paginationRes.page,
        totalPage: paginationRes.total_pages,
        totalRecord: paginationRes.total_records
      }
      this.dispatch('setPagination', pagination)
    })
  },
  getCommissionAleoHistory ({ commit }, page) {
    page = page || 1
    PackageService.getCommissionAleoHistory(page).then(res => {
      const result = res.data || {}
      const paginationRes = res.pagination
      commit('SET_COMMISSION_ALEO_HISTORY', UtilService.transformCommAleoHistory(result))
      const pagination = {
        currentPage: paginationRes.page,
        totalPage: paginationRes.total_pages,
        totalRecord: paginationRes.total_records
      }
      this.dispatch('setPagination', pagination)
    })
  },
  getCommissionEstimation ({ commit }) {
    PackageService.getCommissionEstimation().then(res => {
      const result = res.data || {}
      commit('SET_COMMISSION_ESTIMATION', result)
    })
  },
  getCommissionIronHistory ({ commit }, param) {
    const page = param.page || 1
    PackageService.getCommissionIronHistory(page).then(res => {
      const result = res.data || {}
      const paginationRes = res.pagination
      commit('SET_COMMISSION_IRON_HISTORY', UtilService.transformCommIronHistory(result))
      const pagination = {
        currentPage: paginationRes.page,
        totalPage: paginationRes.total_pages,
        totalRecord: paginationRes.total_records
      }
      this.dispatch('setPagination', pagination)
    })
  },
  getCommissionBrandHistory ({ commit }, param) {
    const page = param.page || 1
    PackageService.getCommissionBrandHistory(param.symbol, page).then(res => {
      const result = res.data || {}
      const paginationRes = res.pagination
      commit('SET_COMMISSION_BRAND_HISTORY', UtilService.transformCommBrandHistory(result))
      const pagination = {
        currentPage: paginationRes.page,
        totalPage: paginationRes.total_pages,
        totalRecord: paginationRes.total_records
      }
      this.dispatch('setPagination', pagination)
    })
  },
  buyPackage (__, data) {
    return new Promise((resolve, reject) => {
      PackageService.buyPackage(data).then(rs => {
        resolve(rs.status)
      })
    })
  }
}

export default { state, getters, mutations, actions }
